import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about-container">
      <h1 className="about-title">About Me</h1>

<p className="about-intro">
  Hello! I’m <strong>Aditya Dharoor Kamsali</strong>, a{" "}
  <strong>Microsoft Certified Azure AI Engineer and Principal Software Engineer </strong> 
  with expertise in{" "}
  <strong>full-stack development, cloud technologies, rapid prototyping and generative AI solutions</strong>. 
  I’m passionate about tackling real-world problems with innovative technology solutions. 
  Every day, I seek out new challenges that let me learn, grow, and push the boundaries 
  of what’s possible in software engineering.
</p>



      <p className="about-intro">
        I’ve had the privilege of working on projects that range from
        architecting high-traffic web applications to embedding machine
        learning algorithms into analytics platforms. My approach is hands-on
        and solution-oriented, and I love seeing the tangible impact that
        well-designed software can have on businesses and users around
        the world.
      </p>

      {/* Experience Section */}
      <h2 className="about-section-heading">Experience Highlights</h2>
      <div className="job-cards">
        {/* Principal Software Engineer Card */}
        <div className="job-card">
          <h3 className="job-title">
            Principal Software Engineer – Starkey Hearing (2026 – Present)
          </h3>
          <ul className="job-list">
            <li>
              Support various technical initiatives across the organization,
              delivering scalable, high-quality solutions that help drive
              innovation across our systems.
            </li>
            <li>
              Recognized for strong technical depth and the ability to solve
              complex challenges, partnering across teams to bring solutions
              from concept through implementation.
            </li>
            <li>
              Lead by example and mentor engineers, helping shape technical
              direction across the company.
            </li>
            <li>
              Provide insights and guidance across a wide range of topics,
              including architecture and AI-native solutions.
            </li>
          </ul>
        </div>

        {/* Senior Software Engineer Card */}
       <div className="job-card">
  <h3 className="job-title">
    Senior Software Engineer – Starkey Hearing (2021 – 2026)
  </h3>
  <ul className="job-list">
    <li>
      Authored internal whitepapers and secured executive buy-in, enabling
      enterprise-wide adoption of MCP servers and delivering measurable ROI
      through automation and modularity.
    </li>
    <li>
      Drove innovation by publishing multiple internal whitepapers proposing
      and implementing AI-powered solutions, including scalable MCP server
      adoption.
    </li>
    <li>
      Built a RAG-based AI assistant with Azure AI Studio, providing real-time
      FAQ grounding to resolve common production issues and reduce operator
      response time.
    </li>
    <li>
      Migrated legacy on-premises systems to Azure Cloud (App Service,
      Functions, Queues, SQL DB), improving scalability and reliability.
    </li>
    <li>
      Designed and scaled a global ReactJS + C# web platform, used in 24
      countries with 10,000+ daily hits, enhancing manufacturing visibility and
      coordination.
    </li>
    <li>
      Developed Python ML models with 95% accuracy to predict product return
      rates, integrated into Power BI for proactive decision-making.
    </li>
    <li>
      Implemented CI/CD pipelines with Azure DevOps, reducing deployment cycles
      from days to hours while managing multi-environment setups.
    </li>
    <li>
      Partnered with the DevOps team to containerize applications with Docker
      and pilot AKS, enabling auto-scaling microservices and significantly
      reducing downtime during peak loads.
    </li>
    <li>
      Re-engineered hearing aid programming workflows, improving speed and
      branding operations by 65% and directly increasing production throughput.
    </li>
    <li>
      Led and mentored offshore Agile teams, accelerating sprint delivery by
      20% and resolving critical blockers for junior developers.
    </li>
    <li>
      Collaborated with research teams to implement proprietary machine learning
      models into production, ensuring scalability, reliability, and business
      impact.
    </li>
    <li>
      Assisted in transforming research prototypes into production-ready
      solutions, bridging the gap between experimentation and enterprise
      deployment.
    </li>
    <li>
      Led multiple system integrations across production floors, streamlining
      workflows and improving cross-platform interoperability.
    </li>
  </ul>
</div>


        {/* Software Engineer Card */}
        <div className="job-card">
          <h3 className="job-title">
            Software Engineer – Starkey Hearing (2017 – 2021)
          </h3>
          <ul className="job-list">
            <li>
              Developed web and desktop applications using C#, WPF, AngularJS,
              and React JS.
            </li>
            <li>
              Created AngularJS pages to retrieve data from SQL databases via
              C# web services.
            </li>
            <li>
              Implemented new features in a C# desktop application using WPF,
              XAML, and Microsoft SQL Server.
            </li>
          </ul>
        </div>

        {/* Systems Engineer Card */}
        <div className="job-card">
          <h3 className="job-title">
            Systems Engineer – Tata Consultancy Services (2012 – 2015)
          </h3>
          <ul className="job-list">
            <li>
              Built a proprietary UI automation tool that recorded and replayed
              mouse and keyboard interactions to automate tasks.
            </li>
            <li>
              Developed an automation language using Scriba and VC++.
            </li>
          </ul>
        </div>
      </div>

      {/* Skills Section */}
      <h2 className="about-section-heading">Skills</h2>
      <div className="skills-container">
{/* AI Group */}
<div className="skill-group-card">
  <h3 className="skill-group-title">AI & Machine Learning</h3>
  <ul className="skill-items">
    <li>Generative AI</li>
    <li>Agentic AI</li>
    <li>MCP Servers</li>
    <li>OpenAI</li>
    <li>Gemini</li>
    <li>Azure ML</li>
    <li>Azure AI Studio</li>
    <li>Azure AI Engineer (Certified)</li>
    <li>AI Solution Planning</li>
    <li>Generative AI Solutions</li>
    <li>Agentic Solutions</li>
    <li>Computer Vision</li>
    <li>Natural Language Processing</li>
    <li>Knowledge Mining</li>
  </ul>
</div>


        {/* Front-End Group */}
        <div className="skill-group-card">
          <h3 className="skill-group-title">Front-End Development</h3>
          <ul className="skill-items">
            <li>AngularJS</li>
            <li>React JS</li>
            <li>CSHTML</li>
            <li>CSS</li>
          </ul>
        </div>

        {/* Programming Languages Group */}
        <div className="skill-group-card">
          <h3 className="skill-group-title">Programming Languages</h3>
          <ul className="skill-items">
            <li>C#</li>
            <li>JavaScript</li>
            <li>Python</li>
            <li>Windows Applications</li>
          </ul>
        </div>

        {/* Data / Analytics Group */}
        <div className="skill-group-card">
          <h3 className="skill-group-title">Data & Analytics</h3>
          <ul className="skill-items">
            <li>Microsoft SQL Server</li>
            <li>SSIS, SSRS</li>
            <li>Power BI</li>
            <li>DAX</li>
          </ul>
        </div>

        {/* Cloud / Hosting Group */}
        <div className="skill-group-card">
          <h3 className="skill-group-title">Cloud Platforms</h3>
          <ul className="skill-items">
            <li>Azure</li>
            <li>Google Cloud</li>
            <li>Firebase</li>
          </ul>
        </div>

        {/* Databases Group */}
        <div className="skill-group-card">
          <h3 className="skill-group-title">Databases</h3>
          <ul className="skill-items">
            <li>Oracle</li>
            <li>MySQL</li>
            <li>MongoDB</li>
            <li>SQLite</li>
          </ul>
        </div>

        {/* DevOps / Tools Group */}
        <div className="skill-group-card">
          <h3 className="skill-group-title">DevOps & Tools</h3>
          <ul className="skill-items">
            <li>Azure DevOps, YAML, WiX</li>
            <li>Confluence, Jira, Azure</li>
            <li>Git, TFS, Bitbucket</li>
          </ul>
        </div>
      </div>

      {/* Education Section */}
      <h2 className="about-section-heading">Education</h2>
      <ul className="education-list">
        <li className="education-item">
          <p className="education-degree">
            Masters - Information Technology (2015-2017)
          </p>
          <p>Minnesota State University, Mankato - MN</p>
        </li>
        <li className="education-item">
          <p className="education-degree">
            Bachelors - Computer Science (2008-2012)
          </p>
          <p>Jawaharlal Nehru Technological University, Hyderabad</p>
        </li>
      </ul>

      {/* Publications Section */}
      <h2 className="about-section-heading">Publications</h2>
      <ul className="publication-list">
        <li className="publication-item">
          <p className="publication-title">
            Nursing Evaluation Using Smart Glass
          </p>
          <a 
            href="https://www.sigmarepository.org/convention/2017/presentations_2017/144/"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: 'none', color: '#007bff' }}
          >
            SIGMA Repository Presentation, 2017
          </a>
        </li>
        <li className="publication-item">
          <p className="publication-title">Anti Land Grabbing Software</p>
          <a
            href="https://www.scribd.com/document/102024546/IJRDE-Anti-Land-Grabbing-Software"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: 'none', color: '#007bff' }}
          >
            Scribd Article
          </a>
        </li>
      </ul>

    </div>
  );
}

export default About;
